/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tx_Status_ExpireInputs */

const en_tx_status_expire = /** @type {(inputs: Tx_Status_ExpireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expired`)
};

const id_tx_status_expire = /** @type {(inputs: Tx_Status_ExpireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedaluwarsa`)
};

/**
* | output |
* | --- |
* | "Expired" |
*
* @param {Tx_Status_ExpireInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tx_status_expire = /** @type {((inputs?: Tx_Status_ExpireInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tx_Status_ExpireInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tx_status_expire(inputs)
	return en_tx_status_expire(inputs)
});